export default __webpack_public_path__ + "static/media/polygon-collection.aea8b217.jpg";